module.exports = __webpack_public_path__ + "2124527c61096a683cd985ee8f543129.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/lot_white.svg
// module id = 2751
// module chunks = 0